<!-- Embed-Target für @n8n/chat (im Horizontal-Customizer Panel) -->
<div #embed class="n8n-chat-embed" id="n8n-chat-embed"></div>
